import { httpsCallable } from 'firebase/functions';
import { functions } from './firebaseFunctions';
import { EventCategory } from '#types/System.types';
import type {
    CalculateOptimizationRequest,
    OptimizationResult
} from '#types/System.Optimizer.types';

/**
 * Interface for log event request payload
 */
export interface LogEventRequest {
    eventCategory: EventCategory;
    description: string;
    userId?: string;
    changedValues?: Record<string, { 
        oldValue: string; 
        newValue: string 
    }>;
    meta?: Record<string, any>;
    isError?: boolean;
}

export async function runOptimizationCalculation(
    request: CalculateOptimizationRequest
) {
    const call = httpsCallable<CalculateOptimizationRequest, OptimizationResult>(
        functions,
        'runOptimizationCalculation'
    );
    return await call(request);
}

export async function logEvent(
    request: LogEventRequest
) {
    const call = httpsCallable<LogEventRequest, { success: boolean }>(
        functions,
        'logEvent'
    );
    return await call(request);
}
